module.exports = __webpack_public_path__ + "img/beer-2.2b1df517.jpg";